import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { RouterProvider } from "./router";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { DrawerProvider } from "./context/DrawerContext";
import "./styles.css";

const container = document.getElementById("root")!;
createRoot(container).render(
  <React.StrictMode>
    <ToastProvider>
      <AuthProvider>
        <RouterProvider>
          <DrawerProvider>
            <App />
          </DrawerProvider>
        </RouterProvider>
      </AuthProvider>
    </ToastProvider>
  </React.StrictMode>
);
